<template>
  <div :class="['flex flex-col', itemsClass]">
    <h1 :class="['text-3xl font-bold tracking-tight font-inter', textColorClass, alignClass]">
      <slot />
    </h1>
    <div v-if="underline" :class="['mt-1 rounded-full', underlineHeightClass, underlineWidthClass, underlineBgClass]"></div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    variant: {
      type: String,
      default: 'indigo' // indigo, blue, green, orange, slate, rose
    },
    underline: {
      type: Boolean,
      default: true
    },
    underlineWidth: {
      type: String,
      default: 'md' // sm, md, lg
    }
  },
  computed: {
    alignClass() {
      if (this.align === 'left') return 'text-left'
      if (this.align === 'right') return 'text-right'
      return 'text-center'
    },
    itemsClass() {
      if (this.align === 'left') return 'items-start'
      if (this.align === 'right') return 'items-end'
      return 'items-center'
    },
    textColorClass() {
      const map = {
        indigo: 'text-gray-900',
        blue: 'text-gray-900',
        green: 'text-gray-900',
        orange: 'text-gray-900',
        slate: 'text-gray-900',
        rose: 'text-gray-900'
      }
      return map[this.variant] || 'text-gray-900'
    },
    underlineBgClass() {
      const map = {
        indigo: 'bg-indigo-500',
        blue: 'bg-blue-500',
        green: 'bg-green-500',
        orange: 'bg-orange-500',
        slate: 'bg-slate-400',
        rose: 'bg-rose-500'
      }
      return map[this.variant] || 'bg-indigo-500'
    },
    underlineWidthClass() {
      if (this.underlineWidth === 'lg') return 'w-24'
      if (this.underlineWidth === 'sm') return 'w-12'
      return 'w-16'
    },
    underlineHeightClass() {
      if (this.underlineWidth === 'lg') return 'h-1.5'
      if (this.underlineWidth === 'sm') return 'h-1'
      return 'h-1.5'
    }
  }
}
</script>

<style scoped>
.font-inter {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}
</style>


